module.exports = require('./helpers/bundle-url').getBundleURL('7oLsE') + "logo.c51670a8.svg";